import { useDispatch } from 'react-redux'
import { setSystemMessage } from '../features/systemMessageSlice'

const useHandleError = () => {
  const dispatch = useDispatch()

  return (error) => {
    dispatch(setSystemMessage({ severity: 'error', message: error.message }))
  }
}

export default useHandleError
